<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="data.trainingRoom.name + (T.AUDIO_SELECTION_DIALOG_HEADER | translate)"
	[headerIcon]="{fontIcon: 'fa-volume', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<mat-tab-group color="accent">
			<div class="row">
				<div class="col">
					<mat-tab label="{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG | translate }}">
						<div class="tabContent">
							<div class="col-lg-6 col-md-6 col-sm-6">
								<sim-admin-settings-scroll-entries-con
									[getScrollEntryText]="getInputChannelName.bind(this)"
									(removeEntryEmitter)="removeChannelById($event)"
									[scrollEntries]="data.trainingRoom?.audioInputChannelIds"
								>
									<mat-form-field color="accent" style="width: 100%">
										<mat-label>
											{{ T.CONFIGURATION_EDITOR_AUDIO_CHANNEL_INPUTS | translate }}
										</mat-label>
										<mat-select
											(ngModelChange)="addChannelById($event, data.trainingRoom.audioInputChannelIds)"
											[(ngModel)]="inputChannelId"
										>
											@for (
												audioInputChannel of filteredInputChannels ?? filterInputChannels();
												track audioInputChannel
											) {
												<mat-option [value]="audioInputChannel.id">
													{{ audioInputChannel.displayAdminText }}</mat-option
												>
											}
											<mat-option [value]="null">
												{{ T.CONFIGURATION_EDITOR_AUDIO_NO_AUDIO_INPUT_CHANNEL | translate }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</sim-admin-settings-scroll-entries-con>
							</div>
						</div>
					</mat-tab>
				</div>

				<div class="col">
					<mat-tab
						[label]="
							(settings.audioDeviceMode === AudioDeviceMode.Tesira
								? T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OUTPUTS
								: T.CONFIGURATION_EDITOR_AUDIO_AUDIO_SERVER_ASIO_2_SETTINGS
							) | translate
						"
					>
						<div class="tabContent" style="display: flex; flex-direction: row">
							<!-- ------------- -->
							<!-- VOG-SELECTION -->
							<!-- ------------- -->
							<div class="col-lg-4 col-md-4 col-sm-4">
								<sim-admin-settings-scroll-entries-con
									[getScrollEntryText]="getOutputChannelName.bind(this)"
									(removeEntryEmitter)="removeChannel($event, data.trainingRoom.vogAudioOutputChannels)"
									[scrollEntries]="data.trainingRoom.vogAudioOutputChannels"
								>
									<mat-form-field color="accent" style="width: 100%">
										<mat-label>
											{{ T.CONFIGURATION_EDITOR_AUDIO_VOG_CHANNELS | translate }}
										</mat-label>
										<mat-select
											(ngModelChange)="addChannel($event, data.trainingRoom.vogAudioOutputChannels)"
											[(ngModel)]="vogChannel"
											style="width: 100%"
										>
											@for (
												availableVogAudioOutputChannel of filteredVogOutputChannels ?? filterVogOutputChannels();
												track availableVogAudioOutputChannel
											) {
												<mat-option [value]="availableVogAudioOutputChannel.channel">
													{{ availableVogAudioOutputChannel.displayAdminText }}</mat-option
												>
											}
											<mat-option [value]="null">
												{{ T.CONFIGURATION_EDITOR_AUDIO_NO_VOG_AUDIO_OUTPUT_CHANNEL | translate }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</sim-admin-settings-scroll-entries-con>
							</div>
							<!-- ------------- -->
							<!-- VOP-SELECTION -->
							<!-- ------------- -->
							<div class="col-lg-4 col-md-4 col-sm-4">
								<sim-admin-settings-scroll-entries-con
									[getScrollEntryText]="getOutputChannelName.bind(this)"
									(removeEntryEmitter)="removeChannel($event, data.trainingRoom.vopAudioOutputChannels)"
									[scrollEntries]="data.trainingRoom.vopAudioOutputChannels"
								>
									<mat-form-field color="accent" style="width: 100%">
										<mat-label>
											{{ T.CONFIGURATION_EDITOR_AUDIO_VOP_CHANNELS | translate }}
										</mat-label>
										<mat-select
											(ngModelChange)="addChannel($event, data.trainingRoom.vopAudioOutputChannels)"
											[(ngModel)]="vopChannel"
											style="width: 100%"
										>
											@for (
												availableVopAudioOutputChannel of filteredVopOutputChannels ?? filterVopOutputChannels();
												track availableVopAudioOutputChannel
											) {
												<mat-option [value]="availableVopAudioOutputChannel.channel">
													{{ availableVopAudioOutputChannel.displayAdminText }}
												</mat-option>
											}
											<mat-option [value]="null">
												{{ T.CONFIGURATION_EDITOR_AUDIO_NO_VOP_AUDIO_OUTPUT_CHANNEL | translate }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</sim-admin-settings-scroll-entries-con>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-4">
								<sim-admin-settings-scroll-entries-con
									[getScrollEntryText]="getOutputChannelName.bind(this)"
									(removeEntryEmitter)="removeChannel($event, data.trainingRoom.vttAudioOutputChannels)"
									[scrollEntries]="data.trainingRoom.vttAudioOutputChannels"
								>
									<mat-form-field color="accent" style="width: 100%">
										<mat-label>
											{{ T.CONFIGURATION_EDITOR_AUDIO_VTT_CHANNELS | translate }}
										</mat-label>
										<mat-select
											(ngModelChange)="addChannel($event, data.trainingRoom.vttAudioOutputChannels)"
											[(ngModel)]="vttChannel"
											style="width: 100%"
										>
											@for (
												availableVttAudioOutputChannel of filteredVttOutputChannels ?? filterVttOutputChannels();
												track availableVttAudioOutputChannel
											) {
												<mat-option [value]="availableVttAudioOutputChannel.channel">
													{{ availableVttAudioOutputChannel.displayAdminText }}
												</mat-option>
											}
											<mat-option [value]="null">
												{{ T.CONFIGURATION_EDITOR_AUDIO_NO_VTT_AUDIO_OUTPUT_CHANNEL | translate }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</sim-admin-settings-scroll-entries-con>
							</div>
						</div>
					</mat-tab>
				</div>
			</div>
		</mat-tab-group>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [color]="'warn'" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" />

		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
